import { ICheckoutStock } from '../../../../interfaces/checkout.interface';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';

export function calculateInvestment(stock: ICheckoutStock): number {
    return roundValue(stock.quoteFactor   *
           stock.buyAmount     *
           (stock.editedPrice > 0 ? stock.editedPrice : stock.unitPrice) *
           stressCalc(stock.purchase, stock.stress.value, stock.stress.dayTradeValue, stock.isDayTrade, stock.typeMarket), 1);
}

export function stressCalc(purchase: boolean, stressDefault: number, dayTradeStress: number, isDayTrade: boolean, typeMarket: number): number {
    return isDayTrade ? dayTradeStress / 100 : !purchase || typeMarket === OrderMarketTypeEnum.Future ? stressDefault / 100 : 1;
}

export function getStopVariation(stock: ICheckoutStock, gain: boolean, isFuture: boolean) {
    if (gain) {
        return !isFuture ? stock.stopGainVariation / stock.unitPrice * 100 : stock.stopGainVariation;
    } else {
        return !isFuture ? stock.stopLossVariation / stock.unitPrice * 100 : stock.stopLossVariation;
    }
}


function roundValue(value, factor) {
    return Math.ceil(value / factor) * factor;
}

export function roundPointsInvestment(points: number) {
    return Math.round(points);
}
